import { getIsApiPending, getQuoteForm, getPremiumCalculationUg } from '../../../selectors/ugMotorInsurance/quote';
import {
    apiTransitionShareQuoteForm,
    shareQuoteSuccess,
    shareQuoteFailure,
} from '../../../actions/ugMotorInsurance/quote';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';

export const shareQuoteService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionShareQuoteForm.pending());
            try {
                const resp = await share(store.getState());
                store.dispatch(shareQuoteSuccess(resp.data));
                store.dispatch(apiTransitionShareQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionShareQuoteForm.failure());
                store.dispatch(shareQuoteFailure(e));
            }
        }
    })();
    return next(action);
};

const shareQuotePayload = (state) => {
    const quotation = getQuoteForm(state);
    const premium = getPremiumCalculationUg(state);

    const payload = {
        email: quotation.shareEmail.value,
        carValue: quotation.valuation.value,
        yearOfManufacture: quotation.yearOfManufacture.value,
        basePremiumRate: premium.value.basePremiumRate,
        excessProtectorFees: premium.value.excessProtectorFees || 0,
        uncommonRisksCoveredFees: premium.value.uncommonRisksCoveredFees || 0,
        violenceAndTerrorismFees: premium.value.violenceAndTerrorismFees || 0,
        trainingLevies: premium.value.trainingLevy || 0,
        vatCharge: premium.value.vatCharge || 0,
        annualPremium: premium.value.premium || premium.value.totalPremium || 0,
        stampDuty: premium.value.stampDuty || 0,
    };

    // Change payload here
    return {
        ...payload,
    };
};

const share = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/share-quote/ke';
        return await axios.post(url, shareQuotePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
